import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { ShouldVerifyUserBeforeClaiming } from '@sorare/core/src/components/rewards/ShouldVerifyUserBeforeClaiming';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

import UnclaimedDeliverableItemOrderButton from './UnclaimedDeliverableItemOrder';
import {
  DeliverableItemOrdersToConfirm,
  DeliverableItemOrdersToConfirmVariables,
} from './__generated__/index.graphql';

const UNCLAIMED_DELIVERABLE_ITEM_ORDER_QUERY = gql`
  query DeliverableItemOrdersToConfirm($sport: Sport!) {
    currentUser {
      slug
      unclaimedDeliverableItemOrders(sport: $sport) {
        id
        deliverableItem {
          slug
          id
        }
        ...UnclaimedDeliverableItemOrderButton_deliverableItemOrder
      }
    }
  }
  ${UnclaimedDeliverableItemOrderButton.fragments.deliverableItemOrder}
` as TypedDocumentNode<
  DeliverableItemOrdersToConfirm,
  DeliverableItemOrdersToConfirmVariables
>;

const Root = styled.div`
  padding: var(--double-unit) var(--double-unit) 0;

  @media ${laptopAndAbove} {
    padding: var(--double-unit) var(--triple-unit) 0;
  }
`;

export const UnclaimedDeliverableItemOrders = () => {
  const { data } = useQuery(UNCLAIMED_DELIVERABLE_ITEM_ORDER_QUERY, {
    variables: {
      sport: Sport.FOOTBALL,
    },
  });

  if (!data?.currentUser?.unclaimedDeliverableItemOrders.length) return null;

  return (
    <Root>
      <ShouldVerifyUserBeforeClaiming hasBlockchainRewards>
        {() => (
          <>
            {data?.currentUser?.unclaimedDeliverableItemOrders.map(
              deliverableItemOrder => (
                <UnclaimedDeliverableItemOrderButton
                  key={deliverableItemOrder.id}
                  deliverableItemOrder={deliverableItemOrder}
                />
              )
            )}
          </>
        )}
      </ShouldVerifyUserBeforeClaiming>
    </Root>
  );
};
